import { Stack, Text, Title } from "@mantine/core";
import { FormattedMessage } from "react-intl";
import type { FundSwitchAllocationCardProps } from "../../types";
import { AllocationBarChart } from "../allocationBarChart";
import classes from "./index.module.css";

export function FundSwitchAllocationCard({
  allocation,
}: FundSwitchAllocationCardProps) {
  const items = (allocation?.buildingBlocks ?? [])
    .filter((block) => block.share > 0)
    .map((block) => ({ name: block.name || block.code, share: block.share }));

  if (items.length === 0) return null;

  return (
    <Stack
      gap="md"
      className={classes.card}
      data-testid="fund-switch-allocation"
    >
      <Stack gap={4}>
        <Title ff="var(--wallet-font-family-sambla-sans)" order={3} size="h4">
          <FormattedMessage
            id="adviceSummary.allocationCard.fundSwitch.headline"
            defaultMessage="Fördelningen enligt ditt råd"
          />
        </Title>
        <Text size="sm" c="var(--wallet-color-sambla-group-neutrals-500)">
          <FormattedMessage
            id="adviceSummary.allocationCard.fundSwitch.description"
            defaultMessage="Här ser du hur pengarna bör fördelas när du genomfört dina fondbyten."
          />
        </Text>
      </Stack>

      <AllocationBarChart items={items} />
    </Stack>
  );
}
